<template>
  <div class="">
    <b-row class="d-flex flex-row justify-content-center">
      <b-col lg="4" md="6" sm="12" class="d-flex flex-column align-items-center my-3 food-card" v-for="food in favoriteProducts"
             :key="food.id">

        <m-c12 :image="food.thumbnail" class="set-pointer">
          <template #p-1>

            <router-link class="text-decoration-none" :to="{ name: 'Product', params: {name: food.raw_link} }">
              <h4 class="text-dark w-100">{{ food.name }}</h4>
              <span v-if="food.brand != null" class="text-success"><span>رستوران :</span>{{ food.brand.name }}</span>
            </router-link>

          </template>
        </m-c12>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "FavoriteProducts1",
  computed: {
    ...mapGetters({
      favoriteProducts: 'Product/getFavoriteProducts'
    })
  },
  mounted() {
    this.$store.dispatch('Product/getFavoriteProducts');
  }
}
</script>

<style scoped>

</style>